import styled from '@emotion/styled';
import PropTypes from 'prop-types';
import Icon from './Icon';

const StyledIcon = styled(Icon)`
  fill: none;
`;

const Afternoon = (props) => {
  const { color, ...rest } = props;
  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    <StyledIcon viewBox="0 0 20 20" {...rest}>
      <path
        d="M12.946 7.054a4.167 4.167 0 1 1-5.893 5.892 4.167 4.167 0 0 1 5.893-5.892M10 3.333V1.667M10 18.333v-1.666M15.3 4.7l.592-.592M4.108 15.892L4.7 15.3M16.667 10h1.666M1.667 10h1.666M15.3 15.3l.592.592M4.108 4.108L4.7 4.7"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </StyledIcon>
  );
};

Afternoon.propTypes = {
  color: PropTypes.string
};

Afternoon.defaultProps = {
  color: 'var(--color-text-primary)'
};

export default Afternoon;
